import { createFileRoute } from '@tanstack/react-router';
import JobChangeProcessTemplate from '@/features/agent/job_change_processes/templates/JobChangeProcessTemplate';

export const Route = createFileRoute('/agent/job_change_processes/')({
  component: JobChangeProcess,
  staticData: { title: '選考管理' },
});

function JobChangeProcess() {
  return <JobChangeProcessTemplate />;
}
